// extracted by mini-css-extract-plugin
export default {"forgotForm":"forgotpassword_forgotForm__Ag1nT","link":"forgotpassword_link__znLGB"};